<div class="background"></div>
@if (!ready) {
  <div>
    <app-spinner></app-spinner>
  </div>
} @else {
  <div class="mat-light-theme">
    <div id="feed">
      @if (franchise?.show_in_original_reporting) {
        <a href="/reports" class="title">
          <img src="/assets/tyt_reports_title_graphic.png" alt="TYT Reports">
        </a>
      }
      <div id="real-feed" [class.two-columns]="franchiseId">
        <div>
          @if (recentArticles?.length) {
            <div class="recent-articles">
              @for (article of recentArticles; track article) {
                <tyt-article-list-item [article]="article" [showFranchise]="false">
                </tyt-article-list-item>
              }
            </div>
          }
          @if (franchise) {
            <div class="featured-franchise">
              @if (franchise.identifier !== 'reports') {
                <h1>
                  <div class="image" [responsiveBackgroundImage]="franchise.image"></div>
                  <a [routerLink]="urlForFranchise(franchise)">{{franchise.name}}</a>
                </h1>
              }
              @for (article of franchise.articles; track article) {
                <tyt-article-list-item [article]="article" [showFranchise]="false" [class.first-page]="page == 1">
                </tyt-article-list-item>
              }
              @if (!franchiseId) {
                <a class="more-button" [routerLink]="urlForFranchise(franchise)">More</a>
              }
            </div>
          }
          <div class="franchise-list">
            <h2>
              <img class="logo" src="/assets/tyt-icon.svg" alt="TYT" />
              Reports In Depth
            </h2>
            @for (franchise of franchises; track franchise) {
              <a [routerLink]="urlForFranchise(franchise)">{{franchise.name}}</a>
            }
          </div>
          <a class="more-button" target="_blank" [href]="globalRssUrl"><mat-icon>rss_feed</mat-icon>RSS</a>
          <!-- ??? -->
          <tyt-pager [total]="total" [page]="page" [size]="size" (changePage)="goToPage($event)"></tyt-pager>
        </div>
        @if (!franchiseId) {
          <div>
            <div class="featured-article">
              <tyt-article-list-item [article]="featuredArticle" [showFranchise]="false">
              </tyt-article-list-item>
            </div>
            <div class="articles">
              @for (article of articles; track article) {
                <tyt-article-list-item [article]="article" [showFranchise]="false">
                </tyt-article-list-item>
              }
              <a class="more-button" routerLink="/reports/reports">More</a>
            </div>
          </div>
        }
        <div>
          <div class="newsletter">
            <tyt-newsletter-module class="sidebar" [optins]="['newsletter']"></tyt-newsletter-module>
          </div>
          @if (earlierArticles?.length) {
            <div class="earlier-articles">
              @for (article of earlierArticles; track article) {
                <tyt-article-list-item [article]="article" [showFranchise]="false" [showImage]="false">
                </tyt-article-list-item>
              }
            </div>
          }
          @if (franchise?.enable_article_syndication) {
            <div>
              <a class="more-button" target="_blank" [href]="rssUrl"><mat-icon>rss_feed</mat-icon>RSS</a>
            </div>
          }
          <div class="download">
            <tyt-mobile-ad-block [title]="'Get TYT on the go!'"></tyt-mobile-ad-block>
          </div>
        </div>
      </div>
    </div>
  </div>
}
